<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <div class="header">
          <h3 class="md-headline">
            Promocode Groups
          </h3>

          <md-button
            class="md-primary"
            @click="dialog.active = true"
          >
            Generate promocodes
          </md-button>
        </div>

        <div class="filters">
          <md-field class="searchInput">
            <label>Search promocode groups</label>
            <md-input
              v-model="filters.search"
              @input="onFiltersUpdate"
            />
          </md-field>

          <md-switch
            v-model="filters.onlyActive"
            @change="onFiltersUpdate"
          >
            Only active
          </md-switch>
        </div>

        <md-progress-bar
          v-if="isLoading"
          md-mode="query"
        />
        <md-table v-else>
          <md-table-row>
            <md-table-head>Name</md-table-head>
            <md-table-head>Redeemed / Total / %</md-table-head>
            <md-table-head>Premium time, hrs</md-table-head>
            <md-table-head>Start date</md-table-head>
            <md-table-head>End date</md-table-head>
          </md-table-row>

          <md-table-row
            v-for="group in groups"
            :key="group.id"
          >
            <md-table-cell>
              <a :href="'/promocodes/group/' + group.id">
                {{ group.name }}
              </a>
            </md-table-cell>

            <md-table-cell>
              {{ group.total_redeemed_count }} / {{ group.total_promocodes }} / {{ (group.total_redeemed_count / group.total_promocodes * 100).toFixed(2) }}%
            </md-table-cell>

            <md-table-cell>{{ group.premium_hrs }}</md-table-cell>

            <md-table-cell>{{ (new Date(group.starts_from)).toDateString() }}</md-table-cell>
            <md-table-cell>{{ (new Date(group.valid_until)).toDateString() }}</md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </div>

    <promocode-group-dialog
      :dialog="dialog"
      @submit="onGenerateDialogSubmit"
    />
  </div>
</template>

<script>
import PromocodeGroupDialog from "../components/Forms/PromocodeGroupDialog";
import {debounce} from "lodash";

export default {
  name: "PromocodeGroupsPage",
  components: { PromocodeGroupDialog },
  data() {
      return {
          groups: [],
          isLoading: true,
          filters: {
            onlyActive: true,
            search: "",
          },

          dialog: this.getDefaultDialogState()
      };
  },
  mounted() {
      this.fetchPromocodeGroups();
  },
  methods: {
      fetchPromocodeGroups() {
        this.isLoading = true;

        const params = new URLSearchParams();
        if (this.filters.onlyActive) {
            params.append("status", "active");
        }

        if (this.filters.search) {
            params.append("group", this.filters.search);
        }

        const stringifiedParams = params.toString();

        this.$http.get(`/v1/admin/store/promocode/groups${stringifiedParams ? "?" + stringifiedParams : ""}`)
            .then(res => {
                this.groups = res.data.groups.filter(g => g);
                this.isLoading = false;
            });
      },
      onFiltersUpdate: debounce(function () { this.fetchPromocodeGroups(); }, 1000),
      onGenerateDialogSubmit(form) {
        this.$http.post("/v1/admin/store/promocode/group/generate", form)
          .then(() => {
            this.dialog = this.getDefaultDialogState();
            this.$notify({
              group: "foo",
              title: "Promocodes generated",
            });
            this.fetchPromocodeGroups();
          })
          .catch((err) => {
            console.error("Couldn’t create a promocode group:", err);
            this.dialog.isSubmitting = false;
          });

      },
      getDefaultDialogState() {
        return {
          active: false,
          premiumDurationDays: 1,
          durationHelperText: "24 hours",
          isSubmitting: false,

          form: {
            group: "",
            count: "0",
            starts_from: "",
            valid_until: "",
            isRedeemAllowed: true,
            can_be_summed: false,
            maximum_redeem_times: "1",
            premium_duration_hours: "24"
          }
        };
      }
  }
};
</script>

<style scoped lang="scss">
    .header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
    }

    .filters {
      display: flex;
      align-items: center;
      column-gap: 24px;
      margin-bottom: 30px;
    }

    .searchInput {
      max-width: 200px;
    }
</style>
